import { type ConfirmationType } from "@/__generated__/graphql";
import { ConfirmationDialog } from "@/components/shared/confirmation-dialog";

export function SkipVisitModalContainer({
  firstUnconfirmed,
  onConfirm,
  onCancel,
  loading,
}: {
  firstUnconfirmed?: ConfirmationType;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}) {
  return (
    <ConfirmationDialog
      loading={loading}
      key={firstUnconfirmed?.key}
      confirmText="Yes, Continue"
      cancelText="No"
      onConfirm={onConfirm}
      onCancel={onCancel}
      title="Skip Visit"
      description={firstUnconfirmed?.message ?? ""}
      open
    />
  );
}
